 // Add focus class on tab
 var $body = document.getElementsByTagName("BODY")[0];
 document.addEventListener('keydown', function(e) {
     if (e.keyCode === 9) {
         $body.classList.add('show-focus-outlines');
     }
 });

 // Remove focus class on mousedown (click)
 document.addEventListener('mousedown', function(e) {
     $body.classList.remove('show-focus-outlines');
 });